import { isValid } from "date-fns";

/**
 * Localize a date
 * @function localizeDate
 * @since v0.1.0
 * @param {Date | number | string} date - date to be localized
 * @returns {Date} localized date
 * @version v1.1.0
 * @public
 */
export const localizeDate = (
	rawDate: Date | number | string = new Date()
): Date => {
	const date = new Date(rawDate);

	if (!isValid(date)) return new Date();

	return date;
};
